const chemicalAnalysisModule = (() => {
    'use strict';

    const CONFIGS_LOCATION = 'configs';
    const FEATURES_INFOS = 'features_infos.json';
    const SCROLL_ANIMATION_TIME = 100;
    const PEROXIDES = "Perossidi";
    const ETIL_ESTERS = "Etil-esteri(mg/kg)";

    let _featuresInfosMap = null;

    const initChemicalAnalysis = (lotNumber, blendLotNumber, blendMaterialCode) => {
        $.getJSON(`${CONFIGS_LOCATION}/${FEATURES_INFOS}`, (data) => {
            _featuresInfosMap = data
            $.ajax({
              url: `${commonsModule.getAPIUrl()}/analysis/chemical?blendLot=${blendLotNumber}&materialCode=${blendMaterialCode}`,
              method: 'GET',
              dataType: 'json',
              crossDomain: true,
              success: (response) => {
                if (response === null || response === undefined) {
                  console.error("No chemical analysis found");
                  return;
                }
        
                const features = commonsModule.getFeatures(response);
                _prepareChemicalsTable(lotNumber, features);
              },
              error: (errorResponse) => {
                reject(errorResponse);
              }
            });
        });
    };
    
    const _prepareChemicalsTable = (lotNumber, features) => {
        $(".table-chemical-lot").text(`Lotto N° ${lotNumber.toUpperCase()}`);

        const chemicalElement = $(".table-chemical");

        const template = chemicalElement.find(".row-chemical").clone();
        chemicalElement.find(".row-chemical").remove();

        features.forEach(feature => {
          let significantDigits = 2;
          if (feature.featureName.toLowerCase() === ETIL_ESTERS.toLowerCase()) {
            significantDigits = 0;
            feature.measuredValue = Math.trunc(feature.measuredValue);
            feature.legaleValueProperty = Math.trunc(feature.legaleValueProperty);
            feature.berioMethodValueProperty = Math.trunc(feature.berioMethodValueProperty);
          }
          if (feature.featureName.toLowerCase() === PEROXIDES.toLowerCase()) {
            significantDigits = 1;
          }
          if (feature.featureName !== null || feature.featureName !== undefined) {
              const row = (_prepareRowChemical(
              template.clone(), feature, significantDigits));
              chemicalElement.append(row);
              row.find('.info-feature').click(_onFeatureDialogOpen);
          }
        });
    };
    
    const _prepareRowChemical = (template, feature, significantDigits) => {
        template.find(".row-chemical-label").text(feature.featureName);
        if (_featuresInfosMap[feature.featureName.toLowerCase()] !== undefined) {
        template.find(".row-chemical-label").append(
            `<span class="info-feature" 
            data-feature=${feature.featureName.toLowerCase()} 
            data-toggle="modal" data-target="#features-material-dialog" >
            <img src="assets/images/info.svg">
            </span>`);
        }
        template.find(".row-chemical-value").text(
        commonsModule.formatFloat(feature.measuredValue, significantDigits));
        template.find(".row-chemical-limit-mb").text(
        `≤ ${commonsModule.formatFloat(feature.berioMethodValueProperty, significantDigits)}`);
        template.find(".row-chemical-limit").text(
        `≤ ${commonsModule.formatFloat(feature.legaleValueProperty, significantDigits)}`);
        
        return template;
    };

    const _onFeatureDialogOpen = (event) => {
    const dialog = $("#features-material-dialog");
    dialog.on("shown.bs.modal", () => {
        $('html,body').animate({
        scrollTop: $(".chemical-section").offset().top
        }, SCROLL_ANIMATION_TIME, () => {
        const targetOffset = $(".feature-modal-target").offset();
        dialog.offset(targetOffset);

        dialog.css('visibility', 'visible');
        });
    });

    const featureName = $(event.currentTarget).attr("data-feature");
    dialog.find(".modal-title").text(_featuresInfosMap[featureName].title);
    dialog.find(".modal-feature-description")
    .html(_featuresInfosMap[featureName].description);
    }; 

    return {
      'initChemicalAnalysis': initChemicalAnalysis
    };
})();
const commonsModule = (() => {
    'use strict';

    const OCTOBER_INDEX = 9;

    let _API_URL = null;

    const getAPIUrl = () => {
      return _API_URL;
    };

    const setAPIUrl = (apiUrl) => {
      _API_URL = apiUrl;
    };
  
    const formatFloat = (number, significantDigits = 2) => {
      return number.toFixed(significantDigits)
      .toString().replace(".", ",");
    };
  
    const formatDate = (inputString) => {
      const date = new Date(Date.parse(inputString));
  
      const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`;
      const month = 
        date.getMonth() >= OCTOBER_INDEX ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
  
      return `${day}/${month}/${date.getFullYear()}`;
    };

    const mapValue = (input, rangeA, rangeB) => {
      const value = (input - rangeA.min) * (rangeB.max - rangeB.min) / 
        (rangeA.max - rangeA.min) + rangeB.min;
  
      return clampValue(value, rangeB.min, rangeB.max);
    };
  
    const clampValue = (value, min, max) => {
      if (value > max) {
        value = max;
      } else if (value < min) {
        value = min;
      }
      return value;
    }

    const insertValues = (values) => {
      const keys = Object.keys(values);
      keys.forEach(key => {
        insertValue(key, values[key]);
      });
    };
  
    const insertValue = (query, value) => {
      $(query).text(value);
    };
  
    const getAttachmentData = (code, attachmentType, dataOnly=false) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: `${_API_URL}/attachments/data?code.equals=${code}&type.equals=${attachmentType}`,
          method: 'GET',
          processData: false,
          crossDomain: true,
          success: (response) => {
            resolve(response);
          },
          error: (errorResponse) => {
            reject(errorResponse);
          }
        });
      });
    };

    const initImage = (image, attachment) => {
      return new Promise((resolve, reject) => {
        if (image === null) {
          reject(image);
        }
        if (attachment === null) {
          reject(attachment);
        }

        image.attr('src', `data:${attachment.dataContentType};base64, ${window.atob(attachment.data)}`);
        if (attachment.description) {
          image.attr('alt', attachment.description);
        }
        image.css('visibility', 'visible');

        resolve(image);
      })
    }; 

    const getFeatures = (analysis) => {
      const features = [];
      for (let index = 0; index < 10; index++) {
        if (analysis[`property${index + 1}`]) {
          features.push({
            'featureName': analysis[`property${index + 1}`],
            'measuredValue': analysis[`measuredValueProperty${index + 1}`],
            'berioMethodValueProperty': analysis[`berioMethodValueProperty${index + 1}`],
            'legaleValueProperty': analysis[`legaleValueProperty${index + 1}`],
          });
        }
      }
  
      return features;
    };

    return {
      'getAPIUrl': getAPIUrl,
      'setAPIUrl': setAPIUrl,
      'formatFloat': formatFloat,
      'formatDate': formatDate,
      'mapValue': mapValue,
      'clampValue': clampValue,
      'insertValues': insertValues,
      'insertValue': insertValue,
      'getAttachmentData': getAttachmentData,
      'initImage': initImage,
      'getFeatures': getFeatures
    };
})();
const detailModule = (() => {
    'use strict';
  
    const CONFIGS_LOCATION = 'configs';
    const FEATURES_INFOS = 'features_infos.json';
    const BOTTLE_PARALLAX = 'bottle_parallax.json';
    const LINKS = 'products_links.json';
    const ANALYTICS = 'analytics.json';
    const PARALLAX = 'IMAGE_PARALLAX';
    const BACK_TOP_ANIMATION_TIME = 500;
  
    let _featuresInfosMap = null;
    let _parallaxConfig = null
    let _bottleSizesRatios = null;
  
    const initDetail = () => {
      const params = new URLSearchParams(window.location.search);
      
      if (params.has('lotNumber') === false || 
        params.has('materialCode') === false) {
        return;
      }

      const lotNumber = params.get('lotNumber');
      const materialCode = params.get('materialCode');

      _sendAnalytics(lotNumber);

      // $.getJSON(`${CONFIGS_LOCATION}/${LINKS}`, (data) => {
      //   const url = data[params.get('materialCode')];
      //   if (url != undefined) {
      //     $("#scopri-di-piu").attr("href", url);
      //   }
      // });

      commonsModule.getAttachmentData(materialCode, 'NONE')
      .then(
        noDataresponse => {
          $("#detail").addClass(
            `${noDataresponse.theme.toLowerCase()}-theme`);
          
            $.getJSON(`${CONFIGS_LOCATION}/${BOTTLE_PARALLAX}`, (data) => {
              _parallaxConfig = data;
      
              let productResponse = null; 
              
              _initFeaturesInfosMap();
          
              _getProduct(lotNumber, materialCode)
              .then(response => {
                if (response === null) {
                  return;
                }
          
                productResponse = response;
                _initResume(productResponse, noDataresponse)
          
                chemicalAnalysisModule.initChemicalAnalysis(
                  productResponse.lotNumber, 
                  productResponse.blendLotNumber, 
                  productResponse.blendMaterialCode);
                rawMaterialsModule.initRawMaterials(productResponse);
                mapModule.initMap(productResponse);
                
                $('#btn-top').on('click', () => {
                  $('html, body').animate({
                    scrollTop: 0
                  }, BACK_TOP_ANIMATION_TIME);
                });
          
                return commonsModule.getAttachmentData(materialCode, PARALLAX, true);
              })
              .then(attachmentResponse => {
                commonsModule.initImage($('.bottle'), attachmentResponse)
                .then(response =>  {
                  $('.bottle').on("load", () => {
                    const bottle = $(".bottle");
                      _initBottleImage(_parallaxConfig);
                      _initBottleAnimation(_parallaxConfig); 
                    }
                  );
                
                  window.onresize = () => {
                    graphModule.clearGraph();
                    graphModule.graphDrawHandler(productResponse);
          
                    $('.bottle').css("position", "fixed");
                    if (window.innerWidth < _parallaxConfig.minWindowWidth) {
                      $('.bottle').css("position", "absolute");
                      return;
                    }
                  };
                  
                  graphModule.graphDrawHandler(productResponse);
                });
              })
              .catch(errorResponse => console.error(errorResponse));
            });
        }
      );
  
     
    };

    const _initBottleImage = (parallaxConfig) => {
      const bottle = $(".bottle");
      _bottleSizesRatios = bottle.width() / bottle.height();

      const height = _getBottleHeight(parallaxConfig);
      bottle.height(height);
      bottle.width(height * _bottleSizesRatios);

      const top = _getBottleTop(parallaxConfig);
      const right = _getBottleRight(parallaxConfig);
      bottle.css("top", `${top}`);
      bottle.css("right", `${right}%`);

      if (_isPositionNotFixed(parallaxConfig)) {
        bottle.css("position", "absolute");
      }
    };

    const _getProduct = (lotNumber, materialCode) => {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: `${commonsModule.getAPIUrl()}/products?lotNumber.equals=${lotNumber}&materialCode.equals=${materialCode}`,
          method: 'GET',
          dataType: 'json',
          crossDomain: true,
          success: (response) => {
            if (response === null || response.length === 0) {
              resolve(null);
            }
            resolve(response[0]);
          },
          error: (errorResponse) => {
            reject(errorResponse);
          }
        });
      });
    }
  
    const _initBottleAnimation = (parallaxConfig) => {
      const bottle = $(".bottle");
      bottle.width(bottle.height() * _bottleSizesRatios);

      $(window).resize(() => {
        const height = _getBottleHeight(parallaxConfig);
        bottle.height(height);
        bottle.width(height * _bottleSizesRatios);

        const top = _getBottleTop(parallaxConfig);
        const right = _getBottleRight(parallaxConfig);
        bottle.css("top", `${top}`);
        bottle.css("right", `${right}%`);
      });

      $(window).scroll(() => {
        if (_isPositionNotFixed(parallaxConfig)) {
          $('.bottle').css("position", "absolute");
          return;
        }
        const height = _getBottleHeight(parallaxConfig);
        bottle.height(height);
        bottle.width(height * _bottleSizesRatios);

        const top = _getBottleTop(parallaxConfig);
        const right = _getBottleRight(parallaxConfig);
        bottle.css("top", `${top}`);
        bottle.css("right", `${right}%`);
      });    
    };

    const _getBottleHeight = (parallaxConfig) => {
      if (_isInSafariBigBreakpoint(parallaxConfig)) {
        return parallaxConfig.phonesHeight;
      }

      if (window.innerWidth < parallaxConfig.minWindowWidth) {
        if (window.innerWidth <= parallaxConfig.smallPhonesWindowWidth) {
          return parallaxConfig.smallPhonesHeight;
        }
       
        if (_isInSafariSmallBreakpoint(parallaxConfig)) {
          return parallaxConfig.smallPhonesHeight;
        }
        return parallaxConfig.phonesHeight;
      };

      if (window.innerHeight < parallaxConfig.minWindowHeight) {
        parallaxConfig.maxHeight = 
          window.innerHeight * parallaxConfig.windowHeightScale;
      }

      const height = commonsModule.mapValue(
        $(".bottle").offset().top, 
        { min: parallaxConfig.minOffsetTop, max: parallaxConfig.maxOffsetTop },
        { min: parallaxConfig.minHeight, max: parallaxConfig.maxHeight });

      return height;
    };

    const _getBottleTop = (parallaxConfig) => {
      if (_isInSafariBigBreakpoint(parallaxConfig)) {
        $('.bottle').css("position", "absolute");
        return parallaxConfig.phonesTop;
      }

      if (window.innerWidth < parallaxConfig.minWindowWidth) {
        if (window.innerWidth <= parallaxConfig.smallPhonesWindowWidth) {
          return parallaxConfig.smallPhonesTop;
        }
        return parallaxConfig.phonesTop;
      };
      const height = $(".bottle").height();

      const top = (height - parallaxConfig.minHeight) * 
      (parallaxConfig.minTop - parallaxConfig.maxTop) / 
      (parallaxConfig.maxHeight - parallaxConfig.minHeight) + 
      parallaxConfig.maxTop;
        
      return top;
    };

    const _getBottleRight = (parallaxConfig) => {
      if (_isInSafariBigBreakpoint(parallaxConfig)) {
        return parallaxConfig.phonesRight;
      }

      if (window.innerWidth < parallaxConfig.minWindowWidth) {
        if (window.innerWidth <= parallaxConfig.smallPhonesWindowWidth) {
          return parallaxConfig.smallPhonesRight;
        }
        
        if (_isInSafariSmallBreakpoint(parallaxConfig)) {
          return parallaxConfig.smallPhonesRight;
        }

        return parallaxConfig.phonesRight;
      };
      const height = $(".bottle").height();

      const right = (height - parallaxConfig.minHeight) * 
      (parallaxConfig.minRight - parallaxConfig.maxRight) / 
      (parallaxConfig.maxHeight - parallaxConfig.minHeight) + 
      parallaxConfig.maxRight;
        
      return right;
    };

    const _isSafari = () => {
      const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
      return isSafari;
    }

    const _isInSafariBigBreakpoint = (parallaxConfig) => {
      return _isSafari() && 
      window.innerWidth >= parallaxConfig.safariBreakPointBigMin && 
      window.innerWidth <= parallaxConfig.safariBreakPointBigMax;
    }

    const _isInSafariSmallBreakpoint = (parallaxConfig) => {
      return _isSafari() && 
      window.innerWidth >= parallaxConfig.safariBreakPointSmallMin && 
      window.innerWidth <= parallaxConfig.safariBreakPointSamllMax;
    }

    const _isPositionNotFixed = (parallaxConfig) => {
      return window.innerWidth < parallaxConfig.minWindowWidth;
    };
  
    const _initFeaturesInfosMap = () => {
      $.getJSON(`${CONFIGS_LOCATION}/${FEATURES_INFOS}`, (data) => {
        _featuresInfosMap = data
      });
    };
  
    const _initResume = (product, attachment) => {
      const resumeValues = {
        '.oil-type': `${attachment.oilType}`,
        '.oil-description': `${attachment.description}`,
        '.brand': `${attachment.brand}`,
        '.product-lot': `${product.lotNumber}`,
        '.product-production-date': commonsModule.formatDate(product.productionDate),
        '.product-expiration-date': commonsModule.formatDate(product.expirationDate),
      }
      commonsModule.insertValues(resumeValues);

      $(".spinner-container").css("visibility", "hidden");
    }

    const _sendAnalytics = (lotNumber) => {
      $.getJSON(`${CONFIGS_LOCATION}/${ANALYTICS}`, (data) => {
        const analyticsInfos = data;
        gtag('config', analyticsInfos.analyticsKey, {
          'custom_map': analyticsInfos.lotNumberDimension
        });
        gtag('event', analyticsInfos.lotNumberEvent, {'lotNumber': lotNumber});

      });
      
    }
  
    return {
      'initDetail': initDetail
    };
})();
const graphModule = (() => {
  const CONFIGS_LOCATION = 'configs';
  const PALETTES = 'palettes.json';
  const GRAPH_CONFIG = 'graph_configuration.json';

  const _center = {
    'x': 0,
    'y': 0
  };

  let _svg = null;
  let _radialScale = null;
  let _data = [];

  let _graphConfig = null;
  let _colorPalette = null;
  let _features = null;

  const prepareGraphConfiguration = (product, graphConfig, features) => {
    return new Promise((resolve, reject) => {

      commonsModule.getAttachmentData(product.materialCode, 'NONE')
      .then(attchmentResponse => {
        const theme = attchmentResponse.theme.toLowerCase();
        _prepareGraphColorPalette(theme, graphConfig.colorPalette)
        .then(response => {
          graphConfig.colorPalette = response;
          graphConfig.graphMaxValue = _getGraphMaxValue(graphConfig);
          graphConfig.labelFontSize = _getLabelFontSize(graphConfig);
          graphConfig.width = $(".graph").width();
          graphConfig.height = $(".graph").height();
          graphConfig.lineLenght = graphConfig.maxValue + graphConfig.lineOffset;
          graphConfig.labelOffset = graphConfig.maxValue + graphConfig.labelDistance;
          graphConfig.features = features;
  
          resolve(graphConfig);
        });
      });

    });
  };

  const clearGraph = () => {
    d3.select(".graph").selectAll("*").remove();
  };

  const graphDrawHandler = (product) => {
    $.getJSON(`${CONFIGS_LOCATION}/${GRAPH_CONFIG}`, (data) => {
      _retrieveFeatures(product)
      .then((features) => {
        prepareGraphConfiguration(product, data, features)
        .then(response => {
          if (response === null) {
            return;
          }
          _drawGraph(response);
        })
        .catch(errorResponse => console.error(errorResponse));
      })
      
    });
  };

  const _initGraph = (graphConfig) => {
    _graphConfig = graphConfig;
    _colorPalette = _graphConfig.colorPalette;
    _features = _graphConfig.features;

    let viewBox = _getViewBox(graphConfig);
    
    _svg = d3.select(".graph").append("svg")
    .attr("width", '100%')
    .attr("height", '100%')
    .attr('viewBox', viewBox)
    .attr('preserveAspectRatio','xMinYMin')
    .append("g");

    if ($("svg").length > 1) {
      $("svg")[0].remove();
    }

    _radialScale = d3.scaleLinear()
    .domain([_graphConfig.minValue, _graphConfig.maxValue])
    .range([_graphConfig.graphMinValue, _graphConfig.graphMaxValue]);

    _center.x = _graphConfig.width / 2;
    _center.y = _graphConfig.height / 2;
    
    _data = _normalizeValues();
  };

  const _getViewBox = (graphConfig) => {
    const minSize = Math.min($(".graph").width(),$(".graph").height());
    let offSet = `${graphConfig.viewBoxDesktopOffset} ${graphConfig.viewBoxDesktopOffset}`;
    let scale = graphConfig.viewBoxDesktopScale;
    
    if (window.innerWidth < graphConfig.maxWindowWidth) {
      offSet = `${graphConfig.viewBoxPhoneOffsetX} ${graphConfig.viewBoxPhoneOffsetY}`;
      if (window.innerWidth < graphConfig.smallPhoneWindowWidth) {
        offSet = `${graphConfig.viewSmallPhoneOffsetX} ${graphConfig.viewSmallPhoneOffsetY}`;
      }
      if (window.innerWidth < graphConfig.ultraSmallPhoneWindowWidth) {
        offSet = `${graphConfig.viewUltraSmallPhoneOffsetX} ${graphConfig.viewUltraSmallPhoneOffsetY}`;
      }
      
      scale = graphConfig.viewBoxPhoneScale;
    }

    return `${offSet} ${minSize * scale} ${minSize * scale}`; 
  };

  const _drawGraph = (graphConfig) => {
    _initGraph(graphConfig);
    _drawCircles();
    _drawLines();
    _drawLabels();
    _drawPath();
    _drawPoints();
  };

  const _drawCircles = () => {
    _graphConfig.radiuses.forEach(radius => {
        _drawCircle(_center, radius, _colorPalette.graph, _colorPalette.graphFill);
    });
  };

  const _drawCircle = (center, radius, color, fill, strokeWidth = null) => {
    _svg.append("circle")
        .attr("cx", center.x)
        .attr("cy", center.y)
        .attr("fill", fill)
        .attr("stroke", color)
        .attr("stroke-width", strokeWidth)
        .attr("r", _radialScale(radius));  
  };

  const _drawLines = () => {
    const angleIncrement = 
        _getAngleIncrement(_features);

    for (let angle = 0; angle < Math.PI * 2; 
        angle += angleIncrement) {

        const endingPoint = _angleToPoint(
          angle, 
          _radialScale, 
          _graphConfig.lineLenght);
        
        _svg.append("line")
        .attr("x1", _center.x)
        .attr("y1", _center.y)
        .attr("x2", _center.x + endingPoint.x)
        .attr("y2", _center.y + endingPoint.y)
        .attr("stroke", _colorPalette.graph);
    }
  };

  const _drawLabels = () => {
    const angleIncrement = _getAngleIncrement(_features);
        
    let index = 0;

    for (let angle = 0; angle < Math.PI * 2 && index < _features.length; 
        angle += angleIncrement) {

        let endingPoint = _angleToPoint(
          angle, 
          _radialScale, 
          _graphConfig.labelOffset);

        endingPoint.x += _center.x;
        endingPoint.y += _center.y;

        const label = _features[index].featureName.toUpperCase();

        let textAnchor = _getTextAnchor(
          endingPoint, 
          _center, 
          _graphConfig.tollerance);

        let baseLine = _getTextBaseline(
          endingPoint, 
          _center, 
          _graphConfig.height);
        
        _svg.append("text")
        .attr("x", endingPoint.x)
        .attr("y",  endingPoint.y)
        .attr("text-anchor", textAnchor)
        .attr("dominant-baseline", baseLine)
        .attr("font-size",  _graphConfig.labelFontSize)
        .attr("font-weight", _graphConfig.labelFontWeight)
        .attr("fill", _colorPalette.label)
        .text(label);

        index++;
    }
  };

  const _drawPath = () => {
    let pathDrawFunction = d3.line().x(point => point.x).y(point => point.y);
    
    for (var index = 0; index < _data.length; index++){
        let pathData = _data[index];
        let coordinates = _getPathCoordinates(_features, pathData);

        _svg.append("path")
        .datum(coordinates)
        .attr("d", pathDrawFunction)
        .attr("stroke", _colorPalette.path)
        .attr("fill", _colorPalette.path)
        .attr("opacity", _colorPalette.pathOpacity);
    }
  };

  const _drawPoints = () => {
    let coordinates = [];
    for (let index = 0; index < _data.length; index++){
        let pathData = _data[index];
        coordinates = _getPathCoordinates(_features, pathData);
    }

    for (let index = 0; index < coordinates.length; index++){
      const coord = coordinates[index];
      const value = _data[0][index]
      const radius = commonsModule.mapValue(
        value, 
        { min: _graphConfig.minValue, max: _graphConfig.maxValue },
        { min: 0.2, max: 0.5 });
      const strokeWidth = commonsModule.mapValue(
        value, 
        { min: _graphConfig.minValue, max: _graphConfig.maxValue },
        { min: 2, max: 4 });
      _drawCircle(coord, radius, _colorPalette.point, _colorPalette.pointFill, strokeWidth);
    }
  };

  const _normalizeValues = () => {
    const rawData = [];
    _features.forEach(feature => {
      rawData.push(feature.measuredValue);
    });

    const ratio = Math.max(...rawData) / _graphConfig.maxValue;
    const data = [];

    let plot = {};
    let index = 0;
    _features.forEach(feature => {
      plot[index] = feature.measuredValue / ratio;
      index++;
    });

    data.push(plot);
    
    return data;
  }

  const _angleToPoint = (angle, radialScale, value) => {
      angle = angle - Math.PI / 2;
      const x = Math.cos(angle) * radialScale(value);
      const y = Math.sin(angle) * radialScale(value);

      return { x, y };
  };

  const _getAngleIncrement = (elements) => {
      return Math.PI * 2 / (elements.length);
  };

  const _getTextAnchor = (position, center, tollerance) => {
    let textAnchor = "middle";
    if (position.x > center.x + tollerance) {
        textAnchor = "start";
    }
    if (position.x < center.x - tollerance) {
        textAnchor = "end";
    }

    return textAnchor;
  };

  const _getTextBaseline = (position, center, height) => {
    let baseLine = "middle";
    if (position.y <= center.y - height / 2) {
        baseLine = "baseline";
    }
    if (position.y >= center.y + height / 2) {
        baseLine = "hanging";
    }

    return baseLine;
  };

  const _getPathCoordinates = (_features, pathData) => {
    const featuresKeys = Object.keys(_features);
    let coordinates = [];
    let angle = 0;
    let angleIncrement = _getAngleIncrement(featuresKeys);

    for (let index = 0; index < featuresKeys.length; index++){
        let featureName = featuresKeys[index];
        
        let point = _angleToPoint(angle, _radialScale, pathData[featureName]);
        point.x += _center.x;
        point.y += _center.y;

        coordinates.push(point);

        angle += angleIncrement;
    }

    return coordinates;
  };

  const _prepareGraphColorPalette = (theme, palette) => {
    return  new Promise((resolve, reject) => {
      $.getJSON(`${CONFIGS_LOCATION}/${PALETTES}`, (data) => {
        if (data === null) {
          reject(data);
        }
        palette.path = data[theme].primary;
        palette.point = data[theme].secondary;
        palette.pointFill = data[theme].primary;
      
        resolve(palette);
      })
    })
  };


  const _retrieveFeatures = (product) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${commonsModule.getAPIUrl()}/analysis/organoleptic?materialCode=${product.blendMaterialCode}&blendProductionDate=${product.blendProductionDate}`,
        method: 'GET',
        dataType: 'json',
        crossDomain: true,
        success: (response) => {
          if (response === null || response === undefined) {
            console.error("No organoleptic analysis found");
            return;
          }

          const features = _getFeatures(response);
          resolve(features);
        },
        error: (errorResponse) => {
          reject(errorResponse);
        }
      });
    });
  };

  const _getGraphMaxValue = (graphConfig) => {
    return commonsModule.mapValue(
      $(window).width(), 
      { 
        min: graphConfig.minWindowWidth, 
        max: graphConfig.maxWindowWidth 
      }, 
      { min: graphConfig.minGraphMaxValue, 
        max: graphConfig.maxGraphMaxValue 
      }
    );
  };

  const _getLabelFontSize = (graphConfig) => {
    return commonsModule.mapValue(
      $(window).width(), 
      { 
        min: graphConfig.minWindowWidth, 
        max: graphConfig.maxWindowWidth 
      }, 
      { 
        min: graphConfig.minLabelFontSize, 
        max: graphConfig.maxLabelFontSize 
      }
    );
  };

  const _getFeatures = (analysis) => {
    const features = [];
    for (let index = 0; index < 10; index++) {
      if (analysis[`property${index + 1}`]) {
        features.push({
          'featureName': analysis[`property${index + 1}`],
          'measuredValue': analysis[`measuredValueProperty${index + 1}`],
          'berioMethodValueProperty': analysis[`berioMethodValueProperty${index + 1}`],
          'legaleValueProperty': analysis[`legaleValueProperty${index + 1}`],
        });
      }
    }

    return features;
  };

  return {
    'prepareGraphConfiguration': prepareGraphConfiguration,
    'clearGraph': clearGraph,
    'graphDrawHandler': graphDrawHandler
  };

})();
const indexModule = (() => {
    'use strict';
  
    const DETAIL = 'detail.html';
    const CONFIGS_LOCATION = 'configs';
    const PRODUCTS_FRONT_PAGE = 'front_page_products.json';
    const PALETTES = 'palettes.json';
    const PREVIEW = 'IMAGE_PREVIEW';
    const FRONT = 'IMAGE_FRONT_PAGE';
    const SLIDE_ANIMATION_TIME = 50;
    const MIN_WINDOW_WIDTH_POPOVER = 1070;

    var _palettes = null;
  
    const searchLot = (id) => {
      $.ajax({
        url: `${commonsModule.getAPIUrl()}/products?lotNumber.equals=${id}`,
        method: 'GET',
        dataType: 'json',
        crossDomain: true,
        success: (response) => {
            if (response === null || response.length === 0) {
              _showNoResults(id);
              return;
            }
            _prepareResults(response);
        },
        error: (errorResponse) => {
          reject(errorResponse);
        }
      });
    };
  
    const initFrontPage = () => {
      const lotSearchBar = $("#lot");
  
      lotSearchBar.val(""); // Clear search
  
      lotSearchBar.off().on('keydown', () => {
        $("#results").slideUp(SLIDE_ANIMATION_TIME);
      });
  
      $("#search").off().on('click', () => {
        const id = lotSearchBar.val();
  
        if (id !== null && id.length > 0) {
          searchLot(id.toUpperCase());
        }
      });

      if (window.innerWidth <= MIN_WINDOW_WIDTH_POPOVER) {
        $(".info-popover").attr("data-placement", "bottom")
      }

      $(".info-popover").on('shown.bs.popover', function () {
        if ($(".close-popover").length === 0) {
          return;
        }
        $(".close-popover").click(() => {
          $(".info-popover").popover('hide');
        });
      });
      
      _loadIndexBottleImages();
    };
  
    const _prepareRow = (template, product) => {
      const productImage = template.find('img');
  
      commonsModule.getAttachmentData(product.materialCode, PREVIEW)
      .then(response => {
        const palette = _palettes[response.theme.toLowerCase()];

        template.find(".brand").text(response.brand);
        template.find(".oil-type").text(response.oilType);
        template.find(".oil-description").text(response.description);
        template.find(".oil-format").text(response.format);
        template.css("border-color", palette.primary);

        template.find("a").attr("href", 
        `${DETAIL}?lotNumber=${product.lotNumber}&materialCode=${product.materialCode}`);
        template.find("a").css("color", palette.primary);

        commonsModule.initImage(productImage, response);
      })
      .catch(errorResponse => console.error(errorResponse));
  
      return template;
    };
  
    const _prepareResults = (products) => {
      const resultsElement = $("#results");
  
      $.getJSON(`${CONFIGS_LOCATION}/${PALETTES}`, (data) => {
        _palettes = data;
        const template = resultsElement.children("div:first").clone();
        resultsElement.children("div").remove();
      
        products.forEach(product => {
            resultsElement.append(
              _prepareRow(template.clone(), product));
        });
    
      resultsElement.slideDown(SLIDE_ANIMATION_TIME);
      });
    };
  
    const _loadIndexBottleImages = () => {
      $.getJSON(`${CONFIGS_LOCATION}/${PRODUCTS_FRONT_PAGE}`, (data) => {
        const frontPageProducts = data;
        
        const bottles = $('.bottle-index').get();
        bottles.sort((a, b) => {
            return ($(a).position().top + $(a).position().left) - 
            ($(b).position().top + $(b).position().left);
        })
        
        for (let index = 0; index < frontPageProducts.order.length; index++) {
          
          const materialCode = frontPageProducts[frontPageProducts.order[index]];
  
          commonsModule.getAttachmentData(materialCode, FRONT)
          .then(response => {
            commonsModule.initImage($(bottles[index]), response);
          })
          .catch(errorResponse => console.error(errorResponse));
          
        }
      });
    }
  
    const _showNoResults = (id) => {
      $("#no-result-button").click(); // Open modal
  
      const dialog = $("#no-results-dialog");
  
      dialog.find(".modal-body")
      .text(`Lotto N. “${id}” non trovato`);
      dialog.on("hide.bs.modal", () => {
        $("#lot").val(""); // Clear lot
      });
    }
  
    return {
      'searchLot': searchLot,
      'initFrontPage': initFrontPage,
    };
})();
$(document).ready(() => {
  $.getJSON("configs/application_configuration.json", (data) => {
    if (data === null) {
      console.error("Can't find API Url");
      return;
    }

    $(function () {
      $('[data-toggle="popover"]').popover()
    });

    commonsModule.setAPIUrl(data.API_URL);

    if ($('#lot').length > 0) {
      indexModule.initFrontPage();
    } else {

      detailModule.initDetail();
    }
  });
});
const mapModule = (() => {

    const CONFIGS_LOCATION = 'configs';
    const MAP_CONFIGURATION = 'map_configuration.json';

    let _mapConfiguration = null;

    const initMap = (product) => {
        $.getJSON(`${CONFIGS_LOCATION}/${MAP_CONFIGURATION}`, (data) => {
            _mapConfiguration = data;

            if (product.rawMaterial1Country === null || 
                product.rawMaterial1Country.length === 0) {
                return;
            }
        // const placeQuery = 
        //     `${product.rawMaterial1Region}, ${product.rawMaterial1Country}`;
            const place = 
                `${product.rawMaterial1City} , ${product.rawMaterial1Country}`;
            // $('#map').attr('src', `${_mapConfiguration.mapUrl}${_mapConfiguration.apiKey}&q=${place}`);
            $('.geo').first().toggleClass('fa-map-marker-alt');

            _setMapPlace(place, _mapConfiguration);
        });
    };

    const onClick = (event) => {
        const element = event.currentTarget;

        if (element.hasAttribute('data-place')) {
        const place = element.getAttributeNode('data-place').value;
        $('.geo').removeClass('fa-map-marker-alt');
        $(element).toggleClass('fa-map-marker-alt');

        //$('#map').attr('src', `${_mapConfiguration.mapUrl}${_mapConfiguration.apiKey}&q=${place}`);
        _setMapPlace(place, _mapConfiguration);
        $('html,body').animate({
            scrollTop: $('#map').offset().top
        }, detailModule.SCROLL_ANIMATION_TIME);
        }
    };

    const _setMapPlace = (place, mapConfiguration) => {
        $('#map').attr('src', `${mapConfiguration.mapUrl}${mapConfiguration.apiKey}&q=${place}`);
    }

    return {
        'initMap': initMap,
        'onClick': onClick
    };
})();
  
const rawMaterialsModule = (() => {
    'use strict';
  
    const TOTAL_RAW_MATERIALS = 4;

    const initRawMaterials = (product) => {
      const rawMaterialsElement = $(".raw-materials tbody");
  
      const template = rawMaterialsElement.children("tr:first").clone();
      rawMaterialsElement.children("tr").remove();
  
      for (let index = 1; index <= TOTAL_RAW_MATERIALS; index++) {
        const rawMaterial = _getRawMaterialInfos(product, index);
        if (rawMaterial === null) {
          continue;
        }
        
        rawMaterialsElement.append(_prepareRowRawMaterials(
          template.clone(), rawMaterial));
      }
    };
  
    const _getRawMaterialInfos = (product, index) => {
      const code = `rawMaterial${index}Code`;
        if (product[code] === null || product[code].length === 0 ) {
          return null;
        }
  
        const lot = `rawMaterial${index}Lot`;
        const supplier = `rawMaterial${index}Supplier`;
        const supplierName = `rawMaterial${index}SupplierName`;
        const press = `rawMaterial${index}OilPress`;
        const pressName = `rawMaterial${index}OilPressName`;
        const country = `rawMaterial${index}Country`;
        const region = `rawMaterial${index}Region`;
        const city = `rawMaterial${index}City`;
        const street = `rawMaterial${index}Street`;
        const cultivar = `rawMaterial${index}Cultivar`;
        
        return {
            code: product[code],
            lot: product[lot],
            supplier: product[supplier],
            supplierName: product[supplierName],
            press: product[press],
            pressName: product[pressName],
            country: product[country],
            region: product[region],
            city: product[city],
            street: product[street],
            cultivar: product[cultivar]
        };
    }
  
    const _prepareRowRawMaterials = (template, rawMaterial) => {
      template.find(".raw-material-lot").text(rawMaterial.lot);
      // template.find(".raw-material-oil-press").text(rawMaterial.pressName);
      //const place = `${rawMaterial.country} / ${rawMaterial.region}`;
      const place = `${rawMaterial.country} / ${rawMaterial.city}`;
      template.find(".raw-material-place").text(place);
      template.find(".raw-material-cultivar").text(rawMaterial.cultivar);
      
      const localization = template.find(".raw-material-locate i");
      //const placeQuery = `${rawMaterial.region}, ${rawMaterial.country}`;
      const placeQuery = `${rawMaterial.city}, ${rawMaterial.country}`;
      localization.attr("data-place", placeQuery);
      localization.click(event, mapModule.onClick);
  
      return template;
    };
  
    return {
      'initRawMaterials': initRawMaterials
    };
})();